export default __webpack_public_path__ + "static/media/consumables.3e65c365.svg";